import { useScenesStore } from "../../../../b.providers/ScenesProvider/store"

const getElementByUUID = (uuid: string) => {
  const found = useScenesStore.getState().getGameElements().get(uuid)
  return found
}
export default getElementByUUID